export default __webpack_public_path__ + "static/media/modalError.4d009fa2.png";